(function ( $ ) {

	"use strict";

	$( window ).load( function () {
		/* eslint-disable no-undef */

		var HomePage = macphillips.isHomePageTemplate;
		var AboutUsPage = macphillips.isAboutUsTemplate;

		//In pages where is called Swiper class, add this code
		if ( HomePage === 'true' || AboutUsPage === 'true' ) {

			var mySwiper = new Swiper( '.macphillips-products-slider .swiper-container', {
				slidesPerView: 'auto',
				spaceBetween: 40,
				breakpoints: {
					1024: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 0,
					},
					730: {
						slidesPerView: 1,
						spaceBetween: 0,
					},
				},
				navigation: {
					nextEl: '.macphillips-product-slider-nav-next .swiper-button-next',
					prevEl: '.macphillips-product-slider-nav-prev .swiper-button-prev',
				},
			} );


			mySwiper.slides.each( function ( index ) {

				//add classes for slide border color
				var $slide = index += 1;
				if ( $slide % 3 == 0 ) {
					$( this ).addClass( "macphillips-product-slider__third-slide" );
				}
				var $secondSlide = $( ".macphillips-product-slider__third-slide" ).prev();
				$secondSlide.addClass( "macphillips-product-slider__second-slide" );
				var $firstSlide = $secondSlide.prev();
				$firstSlide.addClass( "macphillips-product-slider__first-slide" );
			} );
			// when slider come to the last slide add classes
			mySwiper.on( 'reachEnd', function () {
				var $slide = $( '.swiper-slide' );
				var lastSlide = $slide.last().prev();
				var activeIndex = mySwiper.activeIndex;
				var activeSlide = mySwiper.slides.eq( activeIndex );

				// if you drag slides to the end
				lastSlide.addClass( 'add-before' );
				activeSlide.addClass( "no-before" );

				// if you click button next
				$( '.macphillips-product-slider-nav-next' ).on( 'click', function () {
					lastSlide.addClass( 'add-before' );
					activeSlide.addClass( "no-before" );
				} );

				mySwiper.on( 'fromEdge', function () {
					//remove classes when slider go back
					activeSlide.removeClass( "no-before" );
					lastSlide.removeClass( 'add-before' );
				} );
			} );
		}

		//If slider has only three slides and don't need a scroll
		if ( $( '.swiper-button-next' ).hasClass( 'swiper-button-disabled' ) && $( '.swiper-button-prev' ).hasClass( 'swiper-button-disabled' ) ) {
			$( '.macphillips-product-slider__navigation' ).css( "display", "none" );
			mySwiper.params.touchRatio = 0;
		}

		//About Us Page Swiper

		//wrap page content with swiper slide class
		$('.macphillips-about-us').wrap('<div class="swiper-slide"></div>');
		//Swiper init
		var aboutUsSwiper = new Swiper( '.macphillips-about-us__content .swiper-container', {
			slidesPerView: 3,
			spaceBetween: 0,
			touchRatio: 0,
			breakpoints: {
				768: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
			},
			navigation: {
				nextEl: '.macphillips-about_us__nav-next .swiper-button-next',
				prevEl: '.macphillips-about_us__nav-prev .swiper-button-prev',
			},
		});

		if ( $(window).innerWidth() < 800 ) {
			aboutUsSwiper.params.touchRatio = 1;
		}

		//About Us Swiper change nav buttons color
		var $buttonWhiteClass = 'swiper-button-white';
		var nextButton = $( '.macphillips-about-us' ).find( '.swiper-button-next' );
		var prevButton = $( '.macphillips-about-us' ).find( '.swiper-button-prev' );
		nextButton.addClass( $buttonWhiteClass );
		prevButton.addClass( $buttonWhiteClass );


		//About Us Page PopUp
		$( '.macphillips-about-us__button' ).toggle( function ( e ) {
				var $this = $( e.currentTarget );
				$this.next().fadeIn();
			},
			function ( e ) {
				var $this = $( e.currentTarget );
				$this.next().fadeOut();
			} );

		// Close PopUp when click is outside of box
		$( 'body' ).click( function ( e ) {
			$( '.macphillips-about-us__popup' ).fadeOut();
		} );
		//Add mCustom Scrollbar on PopUp
		$( '.macphillips-about-us__popup' ).mCustomScrollbar();

	} );
})( jQuery );
